import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './../api/api.service';
import { IDwellingInput } from './../../models/dwellingInput.interface';
import { IDwellingDetectionReturned } from '../../models/dwellingdetection.interface';

@Injectable({
  providedIn: 'root'
})
export class DwellingService {

  constructor(private http: ApiService) { }

  public checkForDwelling(dwelling: IDwellingInput,programtype:number,email:string): Observable<IDwellingDetectionReturned> {
    email = encodeURIComponent(email);
    var address =encodeURIComponent(dwelling.address_Street);
    var city =encodeURIComponent(dwelling.address_City);
    return this.http.get(`/Dwelling/DwellingDetection?Address=${address}&City=${city}&State=${dwelling.address_State}&Zipcode=${dwelling.address_Zip}&Email=${email}&ProgramCycleKey=${dwelling._Ebb_ProgramCycleId}&Programtype=${programtype}`)
      .pipe(map(res => res as IDwellingDetectionReturned));
  }
}
